import { render, staticRenderFns } from "./BindingBasicInfo.vue?vue&type=template&id=066453ce&scoped=true"
import script from "./BindingBasicInfo.vue?vue&type=script&lang=js"
export * from "./BindingBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./BindingBasicInfo.vue?vue&type=style&index=0&id=066453ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "066453ce",
  null
  
)

export default component.exports